module.exports = "/packs/images/homepage/facilities/online_resources~a4e6481364f704a5eefd98da17d5d42b.jpg";